// Auto-generated - do not edit manually
import React from "react";
import { BaseIcon } from "../../BaseIcon";
import type { BaseIconProps } from "../../types";

const solidContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_drag--line"><g id="Union"><path d="M22 16.5H2V14.5H22V16.5Z" style="fill: currentColor"/><path d="M22 9.5H2V7.5H22V9.5Z" style="fill: currentColor"/></g></g></svg>`;
const lineContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_drag--line"><g id="Union"><path d="M22 16.5H2V14.5H22V16.5Z" style="fill: currentColor"/><path d="M22 9.5H2V7.5H22V9.5Z" style="fill: currentColor"/></g></g></svg>`;

export const Drag: React.FC<BaseIconProps> = (props) => (
  <BaseIcon {...props} solidContent={solidContent} lineContent={lineContent} />
);
